<template>
    <home-template>
        <router-link class="menu-btn" v-for="(route, index) in links" :key="index" :to="route.route">
            {{ route.title }}
        </router-link>
    </home-template>
</template>

<script>
import HomeTemplate from '../components/HomeTemplate.vue';
const config = require('../config');

export default {
    components: {
        HomeTemplate,
    },
    data() {
        const links = [
            { title: 'Host Game', route: '/host' },
            { title: 'Join Game', route: '/join' },
            { title: 'Game Sandbox', route: '/sandbox' },
        ];
        if(config.production) {
            for(let link of links) {
                link.route = config.productionRoot + link.route;
            }
        }
        return {
            links
        }
    }
}
</script>

<style scoped>

</style>
